class AppErrorHandler {
  constructor($log, appEvents, uimessages, APP_EVENTS) {
    'ngInject';

    this.$log = $log;
    this.appEvents = appEvents;
    this.uimessages = uimessages;
    this.APP_EVENTS = APP_EVENTS;
  }
  handle(error, customMessage = '', silent = false) {
    if (!silent) {
      const message = customMessage || error.message || 'Unexpected error';
      this.uimessages.notification(
        `${message}. Please try again.`,
        {
          type: 'error',
          expiration: 10000,
        },
      );
    }

    if (error instanceof Error) {
      this.$log.error(error);
    }
  }
  silent(error) {
    return this.handle(error, '', true);
  }
}

export default AppErrorHandler;
